import { styled } from "goober";
import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { MatchRow } from "./Settings/shared";

const RealIconWrap = styled("span")`
  display: flex;
  align-items: center;
  justify-content: center;
  ${MatchRow}:hover & {
    opacity: 0;
  }
`;

const EmptyCheckOverlay = styled("span")`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  ${MatchRow}:hover & {
    opacity: 0.3;
  }
`;

const FilledCheckOverlay = styled("span")`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Hovering anywhere in the row reveals an unfilled check (see RealIconWrap /
// EmptyCheckOverlay) so the row can be multi-selected without leaving the
// dropdown; the real icon stays hidden while staged so it can't show through the
// checkmark cutout of the filled glyph.
const MatchIconSlot = styled("span")`
  position: relative;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &[data-staged="true"] ${RealIconWrap},
  &[data-preview="true"] ${RealIconWrap} {
    opacity: 0;
  }
`;

export function SelectableMatchIcon({
  staged,
  preview,
  onToggle,
  children,
}: {
  staged: boolean;
  preview: boolean;
  onToggle: (shiftKey: boolean) => void;
  children: ReactNode;
}) {
  return (
    <MatchIconSlot
      data-staged={staged ? "true" : undefined}
      data-preview={preview ? "true" : undefined}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onToggle(e.shiftKey);
      }}
    >
      <RealIconWrap>{children}</RealIconWrap>
      {staged || preview ? (
        <FilledCheckOverlay style={{ opacity: staged ? 1 : 0.3 }}>
          <Icon name="check-filled" size={16} color="var(--text-primary)" />
        </FilledCheckOverlay>
      ) : (
        <EmptyCheckOverlay>
          <Icon name="check-empty" size={16} color="var(--text-primary)" />
        </EmptyCheckOverlay>
      )}
    </MatchIconSlot>
  );
}
